import React from 'react';
import { Box, CircularProgress, Fade } from '@mui/material';
import PropTypes from 'prop-types';

const TableLoadingOverlay = ({ loading }) => {
  return (
    <Fade in={loading}>
      <Box sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        backdropFilter: 'blur(4px)',
        zIndex: 100,
        borderRadius: 3,
        pointerEvents: loading ? 'auto' : 'none'
      }}>
        <CircularProgress 
          size={60} 
          thickness={4} 
          sx={{ 
            color: '#0b3d87',
            filter: 'drop-shadow(0 0 10px rgba(11, 61, 135, 0.2))'
          }} 
        />
      </Box>
    </Fade>
  );
};

TableLoadingOverlay.propTypes = {
  loading: PropTypes.bool.isRequired
};

export default TableLoadingOverlay;
 